import { env } from '@/lib/env/client'
import canUseDOM from '@/payload/utils/canUseDOM'

export const getServerSideURL = () => {
  return env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000'
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  return env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000'
}
